import React, { useEffect, useState } from "react";
import { getSuggest } from "../../services/API/axios";
import "./Row.css";
import SongLyrics from "../SongLyrics/SongLyrics";
import AlbumIcon from "@material-ui/icons/Album";
import PersonIcon from "@material-ui/icons/Person";

function Row({ genreType }) {
  const [genre, setGenre] = useState([]);
  const [music, SetMusic] = useState({
    artist: "",
    title: "",
    albumTitle: "",
    picture: "",
  });
  useEffect(() => {
    async function fetchData() {
      const request = await getSuggest.get(genreType);
      console.log(request.data.data);
      setGenre(request.data.data);
      //   setLoading(false);
      return request;
    }
    fetchData();
  }, [genreType]);

  function getLyrics(event) {
    SetMusic({
      artist: event.artist.name,
      title: event.title,
      albumTitle: event.album.title,
      picture: event.artist.picture_medium,
    });
    // SetMusic(event);
  }
  return (
    <div>
      <label className="row__genre"> {genreType}</label>

      <div className="row__row">
        {genre.map((Element) => (
          <div
            className="row__card"
            onClick={() => getLyrics(Element)}
            key={Element.id}
            tabIndex={0}
            role="button"
            onKeyDown={(event) => {
              if (event.keyCode === 13) {
                getLyrics(Element);
              }
            }}
          >
            <img src={Element.artist.picture_medium} alt="" />
            <div className="row__album__title">
              <PersonIcon />
              <label>{Element.artist.name}</label>
            </div>
            <div className="row__album__title">
              <AlbumIcon />
              <label>{Element.album.title}</label>
            </div>
          </div>
        ))}
      </div>
      {music.artist && <SongLyrics music={music} />}
    </div>
  );
}

export default Row;
